module.exports = __webpack_public_path__ + "img/bluequestion.fe3ead95.png";